import { createSingletonLogger } from "./singleton-logger.js";

const DEFAULT_PARENT = "app";

class Nodes {
  // Component identity for logging
  static componentName = "nodes";
  
  #logger;
  #nodes = new Map();
  #instancesChildren = new Map([[DEFAULT_PARENT, new Map()]]);

  constructor() {
    // Initialize the singleton logger
    this.#logger = createSingletonLogger(this);
  }

  set(key, value) {
    this.#nodes.set(key, value);

    const parent = this.#instancesChildren.get(value.props.parentUid);
    this.#instancesChildren.set(value.uid, new Map());

    if (!parent) {
      this.#instancesChildren.get(DEFAULT_PARENT).set(value.uid, value);
      value.props.parentUid = DEFAULT_PARENT;
      return;
    }

    parent.set(value.uid, value);
  }

  get(uid) {
    return this.#nodes.get(uid);
  }

  delete(uid) {
    this.#nodes.delete(uid);
    this.deleteAsChild(uid);
  }

  deleteAsChild(uid) {
    for (const parentUid of this.#instancesChildren.keys()) {
      if (parentUid === uid) {
        this.#instancesChildren.delete(uid);
        continue;
      }

      const mapChildren = this.#instancesChildren.get(parentUid);
      if (mapChildren && mapChildren.has(uid)) {
        mapChildren.delete(uid);
      }
    }
  }

  getAll() {
    return this.#nodes;
  }

  getMapChildrenFor(uid) {
    return this.#instancesChildren.get(uid) || new Map();
  }

  getChildrenFor(uid) {
    return this.getMapChildrenFor(uid);
  }

  getTree() {
    const buildNode = (uid) => {
      const node = this.#nodes.get(uid);
      const childMap = this.#instancesChildren.get(uid) || new Map();
      const children = [];
      for (const childUid of childMap.keys()) {
        children.push(buildNode(childUid));
      }
      return {
        uid,
        namespace: node ? node.namespace : null,
        props: node ? { ...node.props } : {},
        children,
      };
    };
    return buildNode(DEFAULT_PARENT);
  }
}

const nodes = new Nodes();
export { Nodes, nodes };